module.exports = __webpack_public_path__ + "static/media/fivefu-enter-en.ab6da9f8.png";